"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Block = _interopRequireDefault(require("@material-ui/icons/Block"));

var _solarReact = require("@solar/solar-react");

var _solarReact2 = require("@probeton/solar-react");

var _excluded = ["blocked", "blockedLabel", "blockLabel", "unblockLabel", "onBlock", "onUnblock"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UserBlocking = function UserBlocking(_ref) {
  var blocked = _ref.blocked,
      blockedLabel = _ref.blockedLabel,
      blockLabel = _ref.blockLabel,
      unblockLabel = _ref.unblockLabel,
      onBlock = _ref.onBlock,
      onUnblock = _ref.onUnblock,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_solarReact.ListItem, other, /*#__PURE__*/_react["default"].createElement(_solarReact2.ListItemIcon, null, blocked ? /*#__PURE__*/_react["default"].createElement(_Block["default"], null) : ''), /*#__PURE__*/_react["default"].createElement(_solarReact.ListItemText, {
    lines: "single",
    secondary: blocked ? blockedLabel : ''
  }), blocked ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return onUnblock();
    },
    variant: "outlined",
    color: "primary"
  }, unblockLabel) : /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return onBlock();
    },
    variant: "outlined",
    color: "primary"
  }, blockLabel));
};

UserBlocking.propTypes = {
  blocked: _propTypes["default"].bool,
  classes: _propTypes["default"].object,
  blockedLabel: _propTypes["default"].string,
  blockLabel: _propTypes["default"].string,
  unblockLabel: _propTypes["default"].string,
  onBlock: _propTypes["default"].func.isRequired,
  onUnblock: _propTypes["default"].func.isRequired
};
UserBlocking.defaultProps = {
  blockedLabel: 'Toegang geblokkeerd',
  blockLabel: 'Blokkeren',
  unblockLabel: 'Deblokkeren'
};
var _default = UserBlocking;
exports["default"] = _default;